<template lang="pug">
	.audio-track-info--post-effects.flex-col.center(v-if="visible", :class="[mode]", ref="root")
		.flex-row.align-center.justify.full-height(v-if="mode === 'selector'")
			.left.flex-row.space-small
				slot(name="post-effects-left", :postEffects="postEffects")
			.font-small.upper.grey {{headerCaption || $tCaption('Plugins')}}
			.right.flex-row.space-small
				slot(name="post-effects-right")
				DxMenu(v-if="$auth.hasProAudio()", :items="[{ id: 'addButton', icon: 'plus', items: categorizedPlugins, isGroup: true }]", display-expr="name", @item-click="v => addPlugin(v.itemData)", height="50px"
					:showFirstSubmenuMode="{ name: 'onHover' }", :hideSubmenuOnMouseLeave="true")
		template(v-else)
			.flex-row.space-large(v-if="appliedPlugins && appliedPlugins.length")
				.flex-col.space-large.align-center.level-slider
					.upper.grey.font-small {{$tCaption('IN')}}
					AudioTrackerSliderButton(orientation="vertical", length="220px", v-model="postEffects.levelIn", :step="0.01", :round="2", :min="0", :max="1")
				DxScrollView.flex-1(:direction="orientation", height="100%").scroll-view
					.content
						Container.space.plugins-panel(v-if="containerRendered", :class="[mode === 'plugins' ? 'flex-row' : 'flex-col']", ref="container", :orientation="orientation", @drop="onPluginDrop",
							:get-child-payload="(v) => appliedPlugins[v]", :get-ghost-parent="getGhostParent")
							Draggable.audio-track-info--post-effects(v-for="(plugin, pluginIdx) in appliedPlugins", :key="plugin.id")
								.audio-track--plugin.draggable-item
									.plugin-content.flex-row.space.scale-in-ver-center.justify
										.flex-row.space
											.remove-plugin-button.link-button.white.hover.scale.flex-row.align-center.center.font-small(@click.stop="removePlugin(pluginIdx)")
												fas(icon="times")
											.nowrap.font-small.overflow.plugin-name {{plugin.name}}
										DxDropDownButton.preset(v-if="plugin.presets && plugin.presets.length", :useSelectMode="true", :selectedItemKey="plugin.presetId",
											:height="15", :width="120", :items="plugin.presets", keyExpr="id", displayExpr="name", :dropDownOptions="{ minWidth: '260px' }",
											@itemClick="e => onPresetSelect(plugin, e.itemData)")
				.flex-col.space-large.align-center.level-slider
					.upper.grey.font-small {{$tCaption('OUT')}}
					AudioTrackerSliderButton(orientation="vertical", length="220px", v-model="postEffects.levelOut", :step="0.01", :round="2", :min="0", :max="1")
</template>

<script>
	import $ from 'jquery';
	import _ from 'lodash';
	import VueTypes from 'vue-types';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import DxMenu from 'devextreme-vue/menu';
	import postEffects from './postEffects';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import { Container, Draggable } from 'vue-smooth-dnd';
	import AudioTrackerSliderButton from './AudioTrackerSliderButton.vue';

	export default {
		translationCategory: 'audioTracker.AudioTrackInfoPanel',
		name: 'audio-track-info--post-effects',
		components: { DxDropDownButton, DxScrollView, Container, Draggable, DxMenu, AudioTrackerSliderButton },
		props: {
			audioContext: VueTypes.any.def(null),
			tracker: VueTypes.any.def(null),
			postEffects: VueTypes.any.def(null),
			mode: VueTypes.oneOf(['selector', 'plugins', 'plugins-list']).def('selector'),
			visible: VueTypes.bool.def(true),
			disabled: VueTypes.bool.def(false),
			headerCaption: VueTypes.string.def(null),
		},
		data() {
			return {
				plugins: [],
				categorizedPlugins: [],
				containerRendered: true
			}
		},
		mounted() {
			if (__DEBUG__) {
				window[`postEffects_${this.mode}`] = this;
				window.postEffectsHelper = postEffects;
			}
			postEffects.getPlugins().then(r => this.plugins = r);
			postEffects.getCategorizedPlugins().then(r => this.categorizedPlugins = r);
		},
		destroyed() {
		},
		computed: {
			appliedPlugins() {
				return this.postEffects.plugins.map(f => ({ ...(_.find(this.plugins, v => v && v?.id === f?.id) || {}), presetId: f?.presetId })).filter(f => f.id);
			},
			availablePlugins() {
				return this.plugins.filter(f => !this.postEffects?.plugins?.some(e => e.id === f.id));
			},
			orientation() {
				return this.mode === 'plugins' ? 'horizontal' : 'vertical';
			}
		},
		methods: {
			addPlugin(plugin) {
				if (!plugin || plugin?.isGroup) return;

				if (__DEBUG__)
					console.debug('Add plugin', { plugin });

				if (!this.postEffects.plugins.some(f => f?.id === plugin?.id))
					this.postEffects.plugins.push({
						id: plugin.id,
						presetId: plugin.presets && plugin.presets.length && plugin.presets[0].id
					});
			},
			removePlugin(pluginIdx) {
				this.postEffects.plugins.splice(pluginIdx, 1);
			},
			onPluginDrop(e) {
				if (__DEBUG__)
					console.debug('On plugin drop', { e });
				var item = this.postEffects.plugins[e.removedIndex];
				this.postEffects.plugins.splice(e.removedIndex, 1);
				this.postEffects.plugins.splice(e.addedIndex, 0, item);
			},
			onPresetSelect(plugin, preset) {
				if (__DEBUG__)
					console.debug('OnPresetSegetGhostParentlect', { plugin, preset });
				var item = _.find(this.postEffects.plugins, v => v.id === plugin.id);
				if (item) {
					item.presetId = preset.id;
				}
			},
			getGhostParent() {
				return $('body')[0];
			}
		}
	};
</script>
<style lang='scss'>
	.audio-track-info--post-effects--content {
		position: relative;
	}
	.audio-track-info--post-effects {
		&.smooth-dnd-ghost {
			z-index: 10000 !important;
		}
	}
	.audio-track--plugin {
		padding: 0 2px;

		.plugin-content {
			background: #7b7b7b;
			border-radius: 4px;
			color: #fff;
			padding: 4px;

			.plugin-name {
				max-width: 150px;
			}

			.remove-plugin-button {
				padding: 0px 4px;
			}

			.preset {
				.dx-button {
					height: 17px;

					.dx-icon {
						width: 16px !important;
						height: 16px !important;
						background-position: 0px 0px !important;
						background-size: 24px 24px !important;
						padding: 0px !important;
						font-size: 16px !important;
						text-align: center !important;
						line-height: 14px !important;
					}

					.dx-button-text {
						line-height: 12px;
						font-size: 8px;
						color: #fff;
					}

					.dx-button-content {
						padding: 0px 0px 0px 4px;
					}
				}

				.dx-button-text {
					max-width: 150px;
				}
			}
		}
	}

	.audio-track-info--post-effects {
		@import "main/themes/generated/variables.base.scss";
		
		z-index: 10;
		padding: 4px;

		&.selector {
			height: 38px;
		}

		&.plugins {
			position: absolute;
			left: 0px;
			bottom: 0px;
			width: 100%;
		}

		.level-slider {
			min-width: 20px;
		}

		.scale-in-ver-center {
			animation: scale-in-ver-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
		}

		@keyframes scale-in-ver-center {
			0% {
				transform: scaleY(0);
				opacity: 1;
			}
			100% {
				transform: scaleY(1);
				opacity: 1;
			}
		}

	}
</style>
